export default __webpack_public_path__ + "static/property-img4-f8df4437c7d2e145d40f6e002704f63f.jpg";